import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, TextField } from 'emerald-ui';

class SignUpFormCompanyInfo extends Component {
  handleChange = (event) => {
    const value = event.target.value;
    this.props.handleFieldChange({ name: value });
  };

  render() {
    const { name = {} } = this.props;
    return (
      <Row>
        <Col xs={12} md={5} className="sign-up-form-description">
          <p>Company info</p>
          <p>Enter your company name as you would like it displayed on our course search</p>
        </Col>
        <Col xs={12} md={7} className="sign-up-fields-section">
          <TextField
            id="providerName"
            shape="classic"
            placeholder="Big Company Worldwide"
            label="Provider/Sponsor name"
            maxLength="80"
            onChange={this.handleChange}
            value={name.value || ''}
            error={name.displayErrors ? name.errorMsg : ''}
          />
        </Col>
      </Row>
    );
  }
}

SignUpFormCompanyInfo.propTypes = {
  handleFieldChange: PropTypes.func,
  getFieldValue: PropTypes.func,
  name: PropTypes.object,
};

SignUpFormCompanyInfo.defaultProps = {
  handleFieldChange: () => {},
  getFieldValue: () => {},
};

export default SignUpFormCompanyInfo;



// WEBPACK FOOTER //
// ./src/components/SignUpFormCompanyInfo/SignUpFormCompanyInfo.js